import { useContext, useState } from 'react';
import { Box, Tabs, Tab, Modal } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import LogoutIcon from '@mui/icons-material/Logout';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { CrossIcon, PopUpSettingIcon, OutputPopUpArrows } from '../../../../assets/images';
import SetUpTab from '../tabs/setup';
import Configure from '../tabs/configure';
import Test from '../tabs/test';
import { NestedRecord, WorkFlowActionContext } from '../../../../utils/context';
import { nodeDetailsPanelProps } from '../automator.props';

function NodeDetailsPanel({
  selectedNode,
  activeTab,
  setNodes,
  setActiveTab,
  modalData,
  setOpenPanel,
  disableMode,
  setLogout,
}: nodeDetailsPanelProps) {
  const [configModule, setConfigModule] = useState<NestedRecord | string>('');
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [triggerId, setTriggerId] = useState<string>('');
  const [actionId, setActionId] = useState<string>('');
  const [, setAssistantData] = useState<
    {
      id: number;
      label: string;
      description: string;
      username: string;
      prompt: string;
    }[]
  >([]);
  const [testComplete, setTestComplete] = useState<boolean>(false);
  const { workFlowActionData } = useContext(WorkFlowActionContext);

  const savedValue = localStorage?.getItem('workFlowData');
  const setUpTabEnabled =
    selectedNode?.data.node_type === 'trigger'
      ? JSON.parse(savedValue!)?.trigger?.isSetUpTabCompleted
      : workFlowActionData?.isSetUpTabCompleted;
  const configTabEnabled =
    selectedNode?.data.node_type === 'trigger'
      ? JSON.parse(savedValue!)?.trigger?.isConfigTabCompleted
      : workFlowActionData?.isConfigTabCompleted;
  const testTabEnabled =
    selectedNode?.data.node_type === 'trigger'
      ? JSON.parse(savedValue!)?.trigger?.isTestTabCompleted
      : workFlowActionData?.isTestTabCompleted;

  const handleTabChange = (_event: unknown, newValue: number) => setActiveTab(newValue);

  const getTabIcon = (isEnabled: boolean, isActive: boolean) => {
    if (isEnabled || isActive) {
      return <CheckCircleIcon sx={{ color: 'green' }} />;
    }
    return <InfoIcon sx={{ color: 'orange' }} />;
  };

  const content = (
    <Box className={`${modalOpen ? `node-detail-modal-opened` : `node-details-panel`}`}>
      <div className="flex items-center mt-2 px-2 py-[10px] bg-[#F7F9FB] justify-between">
        <div className="flex items-center">
          <img className="mr-2" src={PopUpSettingIcon} alt="settings icon" height={30} width={30} />
          <span className="font-extrabold">{selectedNode?.data?.trigger_type}</span>
        </div>
        <div className="flex items-center">
          {!modalOpen ? (
            <button
              type="button"
              onClick={() => setModalOpen(true)}
              className="hover:cursor-pointer"
            >
              <img
                className="mr-2"
                src={OutputPopUpArrows}
                alt="output pop up arrows"
                height={20}
                width={20}
              />
            </button>
          ) : (
            <LogoutIcon className="mr-2 cursor-pointer" onClick={() => setModalOpen(false)} />
          )}
          <button
            type="button"
            className="hover:cursor-pointer"
            onClick={() => {
              setOpenPanel?.(false);
            }}
          >
            <img className="mr-2" src={CrossIcon} alt="cross icon" height={18} width={18} />
          </button>
        </div>
      </div>
      <div className="tabs-content">
        <Tabs className="Tabs" value={activeTab} onChange={handleTabChange} variant="fullWidth">
          <Tab
            label="Setup"
            sx={{
              fontWeight: 'bold',
              fontSize: '14px',
              textTransform: 'capitalize',
            }}
            icon={getTabIcon(setUpTabEnabled || testTabEnabled, activeTab === 1 || activeTab !== 0)}
            iconPosition="end"
          />
          <Tab
            label="Configure"
            sx={{
              fontWeight: 'bold',
              fontSize: '14px',
              textTransform: 'capitalize',
            }}
            icon={getTabIcon(configTabEnabled || testTabEnabled, activeTab === 2)}
            iconPosition="end"
            disabled={!setUpTabEnabled}
          />
          <Tab
            label="Test"
            sx={{
              fontWeight: 'bold',
              fontSize: '14px',
              textTransform: 'capitalize',
            }}
            icon={getTabIcon(testTabEnabled, false)}
            iconPosition="end"
            disabled={!configTabEnabled}
          />
        </Tabs>
      </div>
      <div className="mt-2 w-full px-2 max-h-64 overflow-y-auto thin-scroller">
        {activeTab === 0 && (
          <SetUpTab
            selectedNode={selectedNode}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            modalData={modalData}
            setConfigModule={setConfigModule}
            // configModule={configModule}
            disableMode={disableMode}
            setAssistantData={setAssistantData}
            // nodes={nodes}
            setLogout={setLogout}
          />
        )}
        {activeTab === 1 && (
          <Configure
            selectedNode={selectedNode}
            configModule={configModule}
            // modalData={modalData}
            setActiveTab={setActiveTab}
            disableMode={disableMode}
            setTriggerId={setTriggerId}
            // assistantData={assistantData}
            setActionId={setActionId}
            setNodes={setNodes}
            setLogout={setLogout}
            activeTab={activeTab}
            actionId={actionId}
            // triggerId={triggerId}
          />
        )}
        {activeTab === 2 && (
          <Test
            selectedNode={selectedNode}
            triggerId={triggerId}
            disableMode={disableMode}
            actionId={actionId}
            // nodes={nodes}
            setOpenPanel={setOpenPanel}
            testComplete={testComplete}
            setTestComplete={setTestComplete}
            setLogout={setLogout}
            // setSelectedNode={setSelectedNode}
          />
        )}
      </div>
    </Box>
  );

  return modalOpen ? (
    <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
      {content}
    </Modal>
  ) : (
    content
  );
}

export default NodeDetailsPanel;
